export const savePersonalDetails = (data) => ({
  type: "SAVE_PERSONAL_DETAILS",
  payload: data,
});

export const saveContactDetails = (data) => ({
  type: "SAVE_CONTACT_DETAILS",
  payload: data,
});

export const saveEducationalDetails = (data) => ({
  type: "SAVE_EDUCATIONAL_DETAILS",
  payload: data,
});

export const saveExperienceDetails = (data) => ({
  type: "SAVE_EXPERIENCE_DETAILS",
  payload: data,
});

export const saveAdditionalDetails = (data) => ({
  type: "SAVE_ADDITIONAL_DETAILS",
  payload: data,
});
export const saveProfessionalReferences = (data) => ({
  type: "SAVE_PROFESSIONALREFERENCES_DETAILS",
  payload: data,
});

export const saveData = (data) => ({
  type: "SAVE_DATA",
  payload: data,
});


export const clearFormData = () => ({
  type: "CLEAR_FORM_DATA",
});

export const goNext = () => ({
  type: "GO_NEXT",
});

export const goBack = () => ({
  type: "GO_BACK",
});

export const savePermissions = (data) => ({
  type: "SAVE_PERMISSIONS",
  payload: data,
});
 
 
